import { Checkbox } from "@/app/(security)/inscription/components/checkbox";

interface CGUSectionProps {
  label: string;
}

export const CGUSection: React.FC<CGUSectionProps> = ({ label }) => {
  return (
    <Checkbox
      labelStart={label}
      styles={{
        wrapper: {
          position: "start",
        },
        input: {
          marginTop: "mt-1",
        },
      }}
    />
  );
};
